export default __webpack_public_path__ + "Erik Nelson.e0c9cec3d3f52c28b208.png";